import type { SessionStatus } from './types'

/**
 * The statuses a session may be requeued from — mirrors `_TERMINAL_STATES` in
 * `nebula/api.py`. Keep in sync.
 *
 * `user_completed` is excluded by intent, not by limitation: that status means
 * a person decided the session was finished, so it is done and there is
 * nothing to rerun. Do not add it here, and do not read Nebula's behaviour as
 * a gap to close upstream — nothing should send it in the first place.
 *
 * `completed` is different and stays retryable: that session finished on its
 * own, and re-running it is a legitimate rerun.
 */
export const RETRYABLE_SESSION_STATUSES: ReadonlySet<SessionStatus> = new Set([
  'completed',
  'failed',
  'cancelled',
])

export const isRetryableSessionStatus = (status: SessionStatus): boolean =>
  RETRYABLE_SESSION_STATUSES.has(status)
